<script setup lang="ts">
import type { HTMLAttributeClass } from '@fondof-ui/types'
import type { BrandHero } from '@storefront-satch/components/molecules/hero/types'
import { clsx } from 'clsx'

interface HeroRootProps extends BrandHero, HTMLAttributeClass {
  hasAdditionalImage?: boolean
  heroId: string
}

const props = defineProps<HeroRootProps>()
</script>
<template>
  <div
    :id="props.anchorId ?? undefined"
    :data-cfid="props.heroId"
    data-label="Hero"
    :data-title="props.internalTitle"
    :class="
      clsx([
        props.specialClass,
        props.class,
        'relative flex flex-wrap overflow-hidden [&>a]:no-underline',
        '[&_img]:max-w-full [&_video]:max-w-full',
        {
          'mb-0': props.removeSpaceBottom,
          'mb-15 md:mb-17.5 lg:mb-20': !props.removeSpaceBottom,
          'mt-15 md:mt-17.5 lg:mt-20':
            props.specialClass?.includes('add-space--top'),
        },
      ])
    "
  >
    <slot />
  </div>
</template>
